import { CONTACT } from "./action";

export function contactUSReducer(state={}, action) {
    switch (action.type) {
        case CONTACT.postContactDetails.success:
            return Object.assign({}, state, {
                ContactInfo: action.data
            });
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/modules/contactUS/reducer.js